import { action } from "easy-peasy";
import { AppSettings } from "../interfaces/appSettings";
import { HeaderMode } from "../../types/HeaderMode";

export const appSettings: AppSettings = {
  headerMode: HeaderMode.Home,
  jobNumber: null,
  warehouse: undefined,
  operationFilter: undefined,
  searchValue: undefined,
  showOnlyOnHoldJobs: false,
  startedJob: undefined,
  jobs: [],
  similarJobs: [],

  setHeaderMode: action((state, payload) => {
    state.headerMode = payload;
  }),

  setJobNumber: action((state, payload) => {
    state.jobNumber = payload;
  }),

  setWarehouse: action((state, payload) => {
    state.warehouse = payload;
  }),

  setOperationFilter: action((state, payload) => {
    state.operationFilter = payload;
  }),

  setSearchValue: action((state, payload) => {
    state.searchValue = payload;
  }),

  setShowOnlyOnHoldJobs: action((state, payload) => {
    state.showOnlyOnHoldJobs = payload;
  }),

  setStartedJob: action((state, payload) => {
    state.startedJob = payload;
  }),

  setJobs: action((state, payload) => {
    state.jobs = payload;
  }),

  setSimilarJobs: action((state, payload) => {
    state.similarJobs = payload;
  }),
};
